/**
 * @description 投保作業-資料填寫頁 1 判斷選取旅遊地點第一筆地區資料用
*/
export enum GeoAreaId {
    /** 台灣地區 */
    Domestic = 'TW',
    /** 歐洲 */
    EU = 'EU',
    /** 美洲 */
    AM = 'AM',
    /** 其他亞洲 */
    AZ = 'AZ',
    /** 其他 */
    Other = 'XA'
}
